// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../states';
import { type GRRulesState, type GRRoundsState } from '../reducers/gr';

const emtpyObj = {};

export const selectGRRulesState = createSelector(
  (state: StateType): GRRulesState => state.gr.rules,
  (rules) => rules ?? emtpyObj,
);

export const selectGRGlobalRules = createSelector(selectGRRulesState, (rules) => rules.global ?? emtpyObj);

export const selectGRRounds = createSelector(
  (state: StateType): GRRoundsState => state.gr.rounds,
  (rounds) => rounds ?? emtpyObj,
);

export const selectStakeRefMultiplicatorGRGlobalRule = createSelector(
  selectGRGlobalRules,
  (globalRules) => globalRules.stakeRefMultiplicator,
);
